import React from 'react';
import styled from 'styled-components';
import { sectionMargins, fontSize } from '../styles';
import { Container, Image } from './ui';

const StyledContainedImage = styled.section`
  ${sectionMargins()};
`;

const StyledFigure = styled.figure`
  ${sectionMargins()};
`;

const StyledFigCaption = styled.figcaption`
  margin-top: 4px;
  text-align: center;
  ${fontSize(14)};
`;

const ContainedImage = ({ image, caption }) => (
  <StyledContainedImage>
    <Container narrow={true}>
      {caption && <StyledFigure>
          <Image
            src={image.url}
            alt={image.title}
            width={960}
            height={520}
            layout="constrained"
          />
        <StyledFigCaption>{caption}</StyledFigCaption>
      </StyledFigure>}
      {!caption && <Image
        src={image.url}
        alt={image.title}
        width={960}
        height={520}
        layout="constrained"
      />}
    </Container>
  </StyledContainedImage>
);

export default ContainedImage;
